import React, { useMemo } from 'react';
import { Box, BoxExtendedProps, Text } from '@common-fe/common-fe';

import theme from '@/styles/theme';

export interface StatusBlockProps extends BoxExtendedProps {
  title: string;
  backgroundColor: 'danger' | 'success' | 'warning' | 'empty';
  testId?: string;
}

const StatusBlock: React.FC<StatusBlockProps> = ({ title, backgroundColor, testId, ...props }) => {
  const currentBackgroundColor = useMemo(() => {
    switch (backgroundColor) {
    case 'danger': {
      return theme.colors.danger;
    }
    case 'success': {
      return theme.colors.success;
    }
    case 'warning': {
      return theme.colors.warning;
    }
    case 'empty': {
      return theme.colors.statusColors.uploading;
    }
    default: {
      return backgroundColor;
    }
    }
  }, [backgroundColor]);

  return (
    <Box
      data-testId={`${testId}_status-block`}
      background={currentBackgroundColor}
      round="snackbarRound"
      pad={{ vertical: 'spacing2', horizontal: 'spacing8' }}
      {...props}
    >
      <Text
        data-testId={`${testId}_status-block_title`}
        color="textOnColor"
        size="small"
        weight={500}
        style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
      >
        {title}
      </Text>
    </Box>
  );
};

export default StatusBlock;
